var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.size_template),function(btn,index){return _c('q-btn',{key:index,attrs:{"flat":"","no-caps":""},on:{"click":function($event){return _vm.setTemplateSize(index)}}},[_vm._v(_vm._s(btn.title))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }